import React from "react";
import Typed from 'react-typed';
import { MdOutlineWork } from "react-icons/md";
import 'animate.css'

const Home = () => {
  const GitHubClick=()=>{
    // window.location.href="https://github.com/krishna-sm";
    window.open('https://github.com/krishna-sm', '_blank');
  }
  const instaClick=()=>{
    window.open("https://www.instagram.com/krishna_agrawal_____/","_blank");
  }
  return (
    <>
      <div className="hero-section">
        <div className="container">
          <div className="row">
            <div className="row">
              <div className="hero-text-column col-lg-6 order-lg-1 order-2">
                <div className="hero-text-wrapper">
                  <h2 className="hero-heading d-flex">
                    Hi, I'm &nbsp;<span className="hero-name d-block animate__animated animate__backInRight">Krishna  </span>
                    <span className="wave">👋</span>
                  </h2>
                  <h3 className="typing-effect">
                    and I am{" "}
                    <Typed
                    strings={[
                      'Team Person .',
                      'React Developer .',
                      'Web Developer .',
                      'PHP Developer .',
                      'Python Developer .',
                      'Data Scientist  .',
                      'Software Developer  .',
                      'Android Developer .']}
                    loop
                    typeSpeed={40}
                />
                  </h3>
                  <h6 className="hero-description">
                    A passionate Full Stack Software Developer 🚀 having a
                    special interest in Frontend technologies and experience of
                    building Web applications with JavaScript / Reactjs / Nodejs
                    and some other cool libraries and frameworks.
                  </h6>
                </div>
                <button
                  type="button"
                  onClick={GitHubClick}
                  className="hero-action btn btn-primary btn-lg"
                >
                  <i className="fa-brands fa-github mr-2"></i> View on Github
                </button>
                <a
                // onClick={instaClick}
                  // type="button"

                  href="#contact"
                  className="hero-action btn btn-primary btn-lg"
                >
                <MdOutlineWork/>  Hire Me
                </a>
              </div>
              <div className="hero-image-column mb-5 col-lg-6 order-lg-2 order-1">
                <div className="hero-image-wrapper">
                  <img
                    src="/img.jpg"
                    className="hero-image "
                    alt="hero"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
